import React from "react";

const CometBg = () => {
  return (
    <div className="position-relative">
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet1.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet2.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet3.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet4.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet5.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet6.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet7.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet8.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet9.svg"} alt='comet'  /></div>
      <div className="comet"><img src={"https://cdn.worldofdypians.com/dypius/comet10.svg"} alt='comet'  /></div>
    </div>
  );
};

export default CometBg;
